import 'reflect-metadata';
import {Container} from 'inversify';
import {CoreDI} from '@fantasmagames/core/src/di/CoreDI';
import DI from '@fantasmagames/slot/src/common/inversify/constants/DI';
import {Settings} from '@fantasmagames/slot/src/common/settings/Settings';
import {ISettings} from '@fantasmagames/slot/src/common/settings/_interfaces/ISettings';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {IModule} from '@fantasmagames/slot/src/common/_interfaces/IModule';
import {IView} from '@fantasmagames/slot/src/common/_interfaces/IView';
import {Logic} from '@fantasmagames/slot/src/logic/Logic';
import {CheatModule} from '@fantasmagames/slot/src/modules/cheat/CheatModule';
import {BetButtonView} from '@fantasmagames/slot/src/modules/keypad/bet/BetButtonView';
import {MenuButtonModule} from '@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonModule';
import {MenuButtonView} from '@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonView';
import {StopAutoplayButtonModule} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonModule';
import {MainMenuModule} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuModule';
import {AutoplayMenuView} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuView';
import {BetlevelMenuView} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuView';
import {SoundManager} from '@fantasmagames/slot/src/sound/SoundManager';
import {GameViewManager} from 'src/GameViewManager';
import {GameViews} from 'src/GameViews';
import {ParticleView} from '@fantasmagames/slot/src/modules/particles/ParticleView';
import {RestoreScreenModule} from '@fantasmagames/slot/src/modules/restoreScreen/RestoreScreenModule';
import {InfoPopupView} from '@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupView';
import {SoundPlayer} from '@fantasmagames/slot/src/sound/SoundPlayer';
import {BaseGame} from '@fantasmagames/slot/src/system/BaseGame';
import {SpinButtonView} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonView';
import {StopAutoplayButtonView} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonView';
import {OrientationModule} from '@fantasmagames/slot/src/modules/orientation/OrientationModule';
import {LogotypeModule} from '@fantasmagames/slot/src/modules/logotype/LogotypeModule';
import {StatisticsWindowModule} from '@fantasmagames/slot/src/modules/statistics/StatisticsWindowModule';
import {GameRulesModule} from '@fantasmagames/slot/src/modules/gamerules/GameRulesModule';
import {PaytableView} from './paytable/PaytableView';
import {GameRulesView} from '@fantasmagames/slot/src/modules/gamerules/GameRulesView';
import {StatisticsWindowView} from '@fantasmagames/slot/src/modules/statistics/StatisticsWindowView';
import {LogotypeView} from '@fantasmagames/slot/src/modules/logotype/LogotypeView';
import {GameWinPresentationView} from 'src/winpresentation/GameWinPresentationView';
import {OrientationView} from '@fantasmagames/slot/src/modules/orientation/OrientationView';
import {GameAvalancheReelsView} from 'src/avalanche/GameAvalancheReelsView';
import {GameAvalancheReelsModule} from 'src/avalanche/GameAvalancheReelsModule';
import {GameCheatView} from 'src/cheats/GameCheatView';
import {GameWinPresentationModule} from 'src/winpresentation/GameWinPresentationModule';
import {RespinModule} from 'src/respin/RespinModule';
import {RespinView} from 'src/respin/RespinView';
import {GameFlowModule} from 'src/flow/GameFlowModule';
import {GameInfoModule} from 'src/info/GameInfoModule';
import {GameInfoView} from 'src/info/GameInfoView';
import {GameBackgroundView} from 'src/background/GameBackgroundView';
import {GameBackgroundModule} from 'src/background/GameBackgroundModule';
import {TopReelsModule} from 'src/topreels/TopReelsModule';
import {TopReelsView} from 'src/topreels/TopReelsView';
import {OverTopReelEffectsView} from 'src/overtopreel/OverTopReelEffectsView';
import {OverTopReelEffectsModule} from 'src/overtopreel/OverTopReelEffectsModule';
import {WildMeterModule} from 'src/wildmeter/WildMeterModule';
import {WildMeterView} from 'src/wildmeter/WildMeterView';
import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';
import {WinLinesPresentationModule} from 'src/winlinespresentation/WinLinesPresentationModule';
import {WinLinesPresentationView} from 'src/winlinespresentation/WinLinesPresentationView';
import {WinFieldModule} from 'src/winfield/WinFieldModule';
import {WinFieldView} from 'src/winfield/WinFieldView';
import {GameSoundPlayer} from 'src/sound/GameSoundPlayer';
import {GameBigWinModule} from 'src/bigwin/GameBigWinModule';
import {GameBigWinView} from 'src/bigwin/GameBigWinView';
import {GameFreeSpinsModule} from 'src/freespins/GameFreeSpinsModule';
import {GameFreeSpinsView} from 'src/freespins/GameFreeSpinsView';
import {FreeSpinsTriggerModule} from 'src/freespinstrigger/FreeSpinsTriggerModule';
import {FreeSpinsTriggerView} from 'src/freespinstrigger/FreeSpinsTriggerView';
import {RecodeFakeCommunicator} from '@fantasmagames/slot/src/logic/integration/RecodeFakeCommunicator';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {RecodeGameNetworkModule} from 'src/network/recode/RecodeGameNetworkModule';
import {GameFreeSpinsInfoModule} from 'src/freespins/info/GameFreeSpinsInfoModule';
import {GameFreeSpinsInfoView} from 'src/freespins/info/GameFreeSpinsInfoView';
import {SoundHandlerModule} from 'src/sound/SoundHandlerModule';
import {GameSoundManager} from 'src/sound/GameSoundManager';
import {RecodeBetlevelMenuModule} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/recode/RecodeBetlevelMenuModule';
import {RecodeAutoplayMenuModule} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/recode/RecodeAutoplayMenuModule';
import {RecodeInfoPopupModule} from '@fantasmagames/slot/src/modules/popupmenus/info/recode/RecodeInfoPopupModule';
import {RecodeSettingsModule} from '@fantasmagames/slot/src/modules/mainmenu/settingsmenu/recode/RecodeSettingsModule';
import {RecodeModule} from '@fantasmagames/slot/src/integration/RecodeModule';
import {RecodeSpinButtonModule} from 'src/spinbutton/RecodeSpinButtonModule';
import {RecodePaytableModule} from 'src/paytable/recode/RecodePaytableModule';
import {InFreeRoundsModule} from '@fantasmagames/slot/src/modules/microgaming/inFreeRounds/InFreeRoundsModule';
import {FreeRoundsScreenModule} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenModule';
import {GameRecodeAnalyticsModule} from 'src/integration/analytics/GameRecodeAnalyticsModule';
import {RecodeAutoPlayButtonView} from '@fantasmagames/slot/src/modules/keypad/autoplay/recode/RecodeAutoPlayButtonView';
import {RecodeMainMenuView} from '@fantasmagames/slot/src/modules/mainmenu/recode/RecodeMainMenuView';
import {InFreeRoundsView} from '@fantasmagames/slot/src/modules/microgaming/inFreeRounds/InFreeRoundsView';
import {RecodeAutoPlayButtonModule} from '@fantasmagames/slot/src/modules/keypad/autoplay/recode/RecodeAutoPlayButtonModule';
import {RecodeBetButtonModule} from '@fantasmagames/slot/src/modules/keypad/bet/recode/RecodeBetButtonModule';
import {GameSwipeInteractionView} from 'src/swipe/GameSwipeInteractionView';
import {GameSettingsView} from 'src/mainmenu/settingsmenu/GameSettingsView';
import {GameAutoplayHandlerModule} from 'src/autoplay/GameAutoplayHandlerModule';
import {GameSwipeInteractionModule} from 'src/swipe/GameSwipeInteractionModule';
import {GameFreeRoundsScreenView} from 'src/freerounds/GameFreeRoundsScreenView';
import {GameStartScreenView} from 'src/startscreen/GameStartScreenView';
import {GameStartScreenModule} from 'src/startscreen/GameStartScreenModule';
import {GameMobileSoundManager} from 'src/sound/GameMobileSoundManager';
import {GameRecodeMainMenuModule} from 'src/mainmenu/GameRecodeMainMenuModule';

export interface ViewBindInstance {
	clazz: { new(): IView };
	id: string;
}

export class RecodeGameInstaller {
	public static run(game: BaseGame, otherStuff: any): void {
		const VAPI: any = otherStuff;
		const container = game.system.container;
		const communicator: RecodeFakeCommunicator = new RecodeFakeCommunicator(VAPI);
		// communicator.addFakeResponse('');
		const gameLogic = new GameRecodeLogic(game.name, container.get(CoreDI.IEventManagerWithAsync), communicator, game.system.device);
		gameLogic.initializeConfig((container.get(CoreDI.ResourceLoader) as ResourcesLoader).getConfig('config.json'));

		container
			.bind<ISettings>(DI.ISettings)
			.to(Settings)
			.inSingletonScope();
		container.bind<Logic>(DI.Logic).toConstantValue(gameLogic);
		container
			.bind<GameViewManager>(DI.ViewManager)
			.to(GameViewManager)
			.inSingletonScope();

		if (game.system.device.isMobile) {
			container
				.bind<SoundManager>(DI.SoundManager)
				.to(GameMobileSoundManager)
				.inSingletonScope();
		} else {
			container
				.bind<SoundManager>(DI.SoundManager)
				.to(GameSoundManager)
				.inSingletonScope();
		}

		container
			.bind<SoundPlayer>(DI.SoundPlayer)
			.to(GameSoundPlayer)
			.inSingletonScope();

		(container.get(DI.SoundPlayer) as SoundPlayer).init();

		this.bindGameModules(
			container,
			RecodeSpinButtonModule,
			GameAvalancheReelsModule,
			GameBackgroundModule,
			GameWinPresentationModule,
			GameBigWinModule,
			RecodePaytableModule,
			//ParticleModule,
			RecodeAutoPlayButtonModule,
			StopAutoplayButtonModule,
			RecodeBetButtonModule,
			MenuButtonModule,
			GameRecodeMainMenuModule,
			RecodeBetlevelMenuModule,
			RecodeAutoplayMenuModule,
			LogotypeModule,
			GameStartScreenModule,
			GameSwipeInteractionModule,
			OrientationModule,
			RecodeInfoPopupModule,
			GameFreeSpinsInfoModule,
			GameFreeSpinsModule,
			GameInfoModule,
			GameRulesModule,
			RecodeSettingsModule,
			RespinModule,
			FreeSpinsTriggerModule,
			TopReelsModule,
			OverTopReelEffectsModule,
			WildMeterModule,
			WinLinesPresentationModule,
			WinFieldModule,
			FreeRoundsScreenModule,
			InFreeRoundsModule,
			// modules with no view
			GameRecodeAnalyticsModule,
			RestoreScreenModule,
			GameAutoplayHandlerModule,
			GameFlowModule,
			RecodeGameNetworkModule,
			SoundHandlerModule,
			RecodeModule,
		);

		if (!__PRODUCTION__) {
			this.bindGameModules(
				container,
				CheatModule,
				StatisticsWindowModule,
			);
		}

		this.bindGameViews(
			container,
			{clazz: SpinButtonView, id: Views.SPIN_BUTTON_VIEW},
			{clazz: GameAvalancheReelsView, id: Views.REELS_VIEW},
			{clazz: GameBackgroundView, id: Views.BACKGROUND_VIEW},
			{clazz: GameWinPresentationView, id: Views.WIN_PRESENTATION_VIEW},
			{clazz: GameBigWinView, id: Views.BIG_WIN_VIEW},
			{clazz: PaytableView, id: GameViews.PAYTABLE_VIEW},
			{clazz: ParticleView, id: Views.PARTICLE_VIEW},
			{clazz: RecodeAutoPlayButtonView, id: Views.AUTOPLAY_VIEW},
			{clazz: StopAutoplayButtonView, id: Views.STOP_AUTOPLAY_BUTTON_VIEW},
			{clazz: BetButtonView, id: Views.BET_VIEW},
			{clazz: MenuButtonView, id: Views.MENUBUTTON_VIEW},
			{clazz: RecodeMainMenuView, id: Views.MAIN_MENU_VIEW},
			{clazz: BetlevelMenuView, id: Views.BET_LEVEL_MENU_VIEW},
			{clazz: AutoplayMenuView, id: Views.AUTOPLAY_MENU_VIEW},
			{clazz: LogotypeView, id: Views.LOGOTYPE_VIEW},
			{clazz: GameStartScreenView, id: Views.STARTSCREEN_VIEW},
			{clazz: GameSwipeInteractionView, id: Views.SWIPE_INTERACTION_VIEW},
			{clazz: OrientationView, id: Views.ORIENTATION_NOTIFICATION_VIEW},
			{clazz: InfoPopupView, id: Views.INFO_POPUP_VIEW},
			{clazz: GameFreeSpinsInfoView, id: Views.FREE_SPINS_INFO_VIEW},
			{clazz: GameFreeSpinsView, id: Views.FREE_SPINS_VIEW},
			{clazz: GameInfoView, id: Views.INFO_VIEW},
			{clazz: GameRulesView, id: Views.GAME_RULES_VIEW},
			{clazz: GameSettingsView, id: Views.SETTINGS_VIEW},
			{clazz: RespinView, id: GameViews.RESPIN_VIEW},
			{clazz: FreeSpinsTriggerView, id: GameViews.FREE_SPINS_TRIGGER_VIEW},
			{clazz: TopReelsView, id: GameViews.TOP_REELS_VIEW},
			{clazz: OverTopReelEffectsView, id: GameViews.UNDER_TOP_REELS_VIEW},
			{clazz: WildMeterView, id: GameViews.WILD_METER_VIEW},
			{clazz: WinLinesPresentationView, id: GameViews.WIN_LINES_PRESENTATION_VIEW},
			{clazz: WinFieldView, id: GameViews.WIN_FIELD_VIEW},
			{clazz: GameFreeRoundsScreenView, id: Views.MICROGAMING_FREEROUNDS_VIEW},
			{clazz: InFreeRoundsView, id: Views.MICROGAMING_INFREEROUNDS_VIEW},
		);

		if (!__PRODUCTION__) {
			this.bindGameViews(
				container,
				{clazz: GameCheatView, id: Views.CHEATS_VIEW},
				{clazz: StatisticsWindowView, id: Views.STATISTICS_WINDOW_VIEW},
			);
		}

		if (game.system.device.isMobile) {
			/*this.bindGameViews(
				container,
			);*/
		} else {
			/*this.bindGameViews(
				container,

			);*/
		}
	}

	/**
	 * binds like: container.bind<IModule>(DI.IModule).to(BigWinModule);
	 * @param {Container} container
	 * @param {{new(): IModule}} gameModuleClasses
	 */
	protected static bindGameModules(container: Container, ...gameModuleClasses: { new(): IModule }[]): void {
		for (const module of gameModuleClasses) {
			container.bind(DI.IModule).to(module);
		}
	}

	protected static bindGameViews(container: Container, ...gameViewClasses: ViewBindInstance[]): void {
		for (const bindInstance of gameViewClasses) {
			container.bind(bindInstance.id).to(bindInstance.clazz);
		}
	}
}



// WEBPACK FOOTER //
// ./src/RecodeGameInstaller.ts